module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-crud-index', {
    attrs: {
      "model": _vm.model,
      "action": "index",
      "root-config": _vm.rootConfig,
      "config": _vm.config
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d85806"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueCrudTable.vue
// module id = 522
// module chunks = 1